import React from 'react';
import './buttonStyle.css';
const OrangeButton = ({ label, onClick = () => {}, className = '' }) => {
  return (
    <button
      onClick={onClick}
      className={`cta-button primary fredokaOne !font-normal shadow-[0px_1px_2px_0px_rgba(255,255,255,0.40)inset,0px_4px_4px_0px_rgba(255,255,255,0.35)inset] ${className}`}
    >
      {label}
    </button>
  );
};

export default OrangeButton;
